// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SiteLogo_wrapper__l8REt","image":"SiteLogo_image__WgdVk"};